import { render } from "./EnAboutUs.vue?vue&type=template&id=7f2fd675&scoped=true"
import script from "./EnAboutUs.vue?vue&type=script&lang=js"
export * from "./EnAboutUs.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/en/Aboutus.css?vue&type=style&index=1&id=7f2fd675&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2fd675"]])

export default __exports__